import { UserData } from "./userNormalizer"

export const userDataFormat = (user: UserData) => {
    const userData = {...user}
    if (user.profileImage){
        userData.profileImage = user.profileImage.startsWith("uploads") ? import.meta.env.VITE_CDN_LINK + user.profileImage : user.profileImage;
    }
    if (user.seafarerSid){
        userData.seafarerSid = user.seafarerSid.startsWith("uploads") ? import.meta.env.VITE_CDN_LINK + user.seafarerSid : user.seafarerSid;
    }
    return userData
}